import {
  FlowTemplate,
  TemplateType,
  TriggerType,
  PieceType,
  PackageType,
} from '@activepieces/shared';

export const kizeoTemplates: FlowTemplate[] = [
  {
    id: 'kizeo-forms_event_on_data_finished-to-gmail-send_email',
    created: '1745917535896',
    updated: '1745917535896',
    name: 'Real-time notifications',
    description: 'Receive an email whenever a new data entry is added',
    tags: [],
    pieces: ['@activepieces/piece-kizeo-forms', '@activepieces/piece-gmail'],
    template: {
      displayName: 'untitled',
      triggers: [
        {
          name: 'trigger',
          valid: false,
          displayName: 'Event on data finished',
          type: TriggerType.PIECE,
          settings: {
            pieceName: '@activepieces/piece-kizeo-forms',
            pieceVersion: '~0.8.1',
            pieceType: PieceType.OFFICIAL,
            packageType: PackageType.REGISTRY,
            input: {
              format: 'simple',
            },
            inputUiInfo: {
              customizedInputs: {},
            },
            position: {
              x: 0,
              y: 0,
            },
            triggerName: 'event_on_data_finished',
          },
        },
      ],
      actions: [
        {
          name: 'step_1',
          skip: false,
          type: 'PIECE',
          valid: false,
          settings: {
            input: {
              cc: [],
              bcc: [],
              draft: false,
              receiver: [],
              reply_to: [],
              body_type: 'plain_text',
            },
            position: {
              x: 200,
              y: 0,
            },
            pieceName: '@activepieces/piece-gmail',
            pieceType: 'OFFICIAL',
            actionName: 'send_email',
            inputUiInfo: {
              customizedInputs: {},
            },
            packageType: 'REGISTRY',
            pieceVersion: '~0.8.1',
            executionOptions: {
              executeOnce: {
                value: false,
              },
            },
            errorHandlingOptions: {
              retryOnFailure: {
                value: false,
              },
              continueOnFailure: {
                value: false,
              },
            },
          },
          displayName: 'Send Email',
        },
      ],
      connections: [
        {
          sourceId: 'trigger',
          targetId: 'step_1',
        },
      ],
      valid: false,
      schemaVersion: '1',
      dynamicPropertiesValues: {},
    },
    blogUrl: '',
    projectId: '',
    platformId: '',
    type: TemplateType.PROJECT,
  },
  {
    id: 'kizeo-forms_event_on_data_finished-to-google-sheets_insert_row',
    created: '1745936201323',
    updated: '1745936201323',
    name: 'Spreadsheet synchronization',
    description: 'Populate a spreadsheet with newly entered data',
    tags: [],
    pieces: [
      '@activepieces/piece-kizeo-forms',
      '@activepieces/piece-google-sheets',
    ],
    template: {
      displayName: 'Untitled',
      triggers: [
        {
          name: 'trigger',
          valid: false,
          displayName: 'Event on data finished',
          type: TriggerType.PIECE,
          settings: {
            pieceName: '@activepieces/piece-kizeo-forms',
            pieceVersion: '~0.8.1',
            pieceType: PieceType.OFFICIAL,
            packageType: PackageType.REGISTRY,
            input: {
              format: 'simple',
            },
            inputUiInfo: {
              customizedInputs: {},
            },
            position: {
              x: 0,
              y: 0,
            },
            triggerName: 'event_on_data_finished',
          },
        },
      ],
      actions: [
        {
          name: 'step_1',
          skip: false,
          type: 'PIECE',
          valid: false,
          settings: {
            input: {
              values: {},
              as_string: false,
              first_row_headers: false,
              includeTeamDrives: false,
            },
            position: {
              x: 200,
              y: 0,
            },
            pieceName: '@activepieces/piece-google-sheets',
            pieceType: 'OFFICIAL',
            actionName: 'insert_row',
            inputUiInfo: {
              customizedInputs: {},
            },
            packageType: 'REGISTRY',
            pieceVersion: '~0.12.12',
            executionOptions: {
              executeOnce: {
                value: false,
              },
            },
            errorHandlingOptions: {
              retryOnFailure: {
                value: false,
              },
              continueOnFailure: {
                value: false,
              },
            },
          },
          displayName: 'Insert Row',
        },
      ],
      connections: [
        {
          sourceId: 'trigger',
          targetId: 'step_1',
        },
      ],
      valid: false,
      schemaVersion: '1',
      dynamicPropertiesValues: {},
    },
    blogUrl: '',
    projectId: '',
    platformId: '',
    type: TemplateType.PROJECT,
  },
  {
    id: 'google-sheets_googlesheets_new_row_added-to-kizeo-forms_create_list_item',
    created: '1745937960931',
    updated: '1745937960931',
    name: 'New advanced list item from Google Sheets',
    description:
      'Add new items to your advanced list for each new row in your Google Sheet',
    tags: [],
    pieces: [
      '@activepieces/piece-google-sheets',
      '@activepieces/piece-kizeo-forms',
    ],
    template: {
      displayName: 'Untitled',
      triggers: [
        {
          name: 'trigger',
          valid: false,
          displayName: 'Googlesheets new row added',
          type: TriggerType.PIECE,
          settings: {
            pieceName: '@activepieces/piece-google-sheets',
            pieceVersion: '~0.12.12',
            pieceType: PieceType.OFFICIAL,
            packageType: PackageType.REGISTRY,
            input: {
              includeTeamDrives: false,
            },
            inputUiInfo: {
              customizedInputs: {},
            },
            position: {
              x: 0,
              y: 0,
            },
            triggerName: 'googlesheets_new_row_added',
          },
        },
      ],
      actions: [
        {
          name: 'step_1',
          skip: false,
          type: 'PIECE',
          valid: false,
          settings: {
            input: {
              properties: {},
            },
            position: {
              x: 200,
              y: 0,
            },
            pieceName: '@activepieces/piece-kizeo-forms',
            pieceType: 'OFFICIAL',
            actionName: 'create_list_item',
            inputUiInfo: {
              customizedInputs: {},
            },
            packageType: 'REGISTRY',
            pieceVersion: '~0.8.1',
            executionOptions: {
              executeOnce: {
                value: false,
              },
            },
            errorHandlingOptions: {
              retryOnFailure: {
                value: false,
              },
              continueOnFailure: {
                value: false,
              },
            },
          },
          displayName: 'Create List Item',
        },
      ],
      connections: [
        {
          sourceId: 'trigger',
          targetId: 'step_1',
        },
      ],
      valid: false,
      schemaVersion: '1',
      dynamicPropertiesValues: {},
    },
    blogUrl: '',
    projectId: '',
    platformId: '',
    type: TemplateType.PROJECT,
  },
  {
    id: 'kizeo-forms_event_on_data_finished-to-hubspot_create-deal',
    created: '1757324446172',
    updated: '1757324446172',
    name: 'CRM updates',
    description: 'Create new deals from Kizeo Forms data',
    tags: [],
    pieces: ['@activepieces/piece-kizeo-forms', '@activepieces/piece-hubspot'],
    template: {
      displayName: 'Untitled',
      triggers: [
        {
          name: 'trigger',
          valid: false,
          displayName: 'Event On Data Finished',
          type: TriggerType.PIECE,
          settings: {
            pieceName: '@activepieces/piece-kizeo-forms',
            pieceVersion: '~0.8.1',
            pieceType: PieceType.OFFICIAL,
            packageType: PackageType.REGISTRY,
            input: {
              formId: null,
              format: 'simple',
            },
            inputUiInfo: {
              customizedInputs: {},
            },
            position: {
              x: 0,
              y: 0,
            },
            triggerName: 'event_on_data_finished',
          },
        },
      ],
      actions: [
        {
          name: 'step_1',
          skip: false,
          type: 'PIECE',
          valid: false,
          settings: {
            input: {
              objectProperties: {},
            },
            position: {
              x: 200,
              y: 0,
            },
            pieceName: '@activepieces/piece-hubspot',
            pieceType: 'OFFICIAL',
            actionName: 'create-deal',
            inputUiInfo: {
              customizedInputs: {},
            },
            packageType: 'REGISTRY',
            pieceVersion: '~0.6.1',
            executionOptions: {
              executeOnce: {
                value: false,
              },
            },
            errorHandlingOptions: {
              retryOnFailure: {
                value: false,
              },
              continueOnFailure: {
                value: false,
              },
            },
          },
          displayName: 'Create Deal',
        },
      ],
      connections: [
        {
          sourceId: 'trigger',
          targetId: 'step_1',
        },
      ],
      valid: false,
      schemaVersion: '1',
      dynamicPropertiesValues: {},
    },
    blogUrl: '',
    projectId: '',
    platformId: '',
    type: TemplateType.PROJECT,
  },
  {
    id: 'schedule_every_week-to-google-drive_upload_gdrive_file',
    created: '1767773204142',
    updated: '1767773204142',
    name: 'Weekly data report on Drive',
    description:
      'Automatically download all of the week’s data directly to your Drive',
    tags: [],
    pieces: [
      '@activepieces/piece-schedule',
      '@activepieces/piece-store',
      '@activepieces/piece-google-drive',
      '@activepieces/piece-kizeo-forms',
    ],
    template: {
      displayName: 'untitled',
      triggers: [
        {
          name: 'trigger',
          valid: true,
          displayName: 'Every week',
          type: TriggerType.PIECE,
          settings: {
            pieceName: '@activepieces/piece-schedule',
            pieceVersion: '~0.2.6',
            pieceType: PieceType.OFFICIAL,
            packageType: PackageType.REGISTRY,
            input: {
              timezone: 'auto',
            },
            inputUiInfo: {
              customizedInputs: {},
            },
            position: {
              x: 0,
              y: 0,
            },
            triggerName: 'every_week',
          },
        },
      ],
      actions: [
        {
          name: 'step_1',
          skip: false,
          type: 'PIECE',
          valid: true,
          settings: {
            input: {
              formId: '1141452',
              filterType: 'DYNAMIC_DATE',
              filterField: null,
              filterValue: '7 days',
              filterOperator: '<=',
            },
            position: {
              x: 200,
              y: 0,
            },
            pieceName: '@activepieces/piece-kizeo-forms',
            pieceType: 'OFFICIAL',
            actionName: 'get_filtered_data',
            inputUiInfo: {
              customizedInputs: {},
            },
            packageType: 'REGISTRY',
            pieceVersion: '~0.8.1',
            executionOptions: {
              executeOnce: {
                value: false,
              },
            },
            errorHandlingOptions: {
              retryOnFailure: {
                value: false,
              },
              continueOnFailure: {
                value: false,
              },
            },
          },
          displayName: 'Get filtered Data',
        },
        {
          name: 'step_2',
          skip: false,
          type: 'PIECE',
          valid: false,
          settings: {
            input: {
              dataIds: [],
            },
            position: {
              x: 1000,
              y: 0,
            },
            pieceName: '@activepieces/piece-kizeo-forms',
            pieceType: 'OFFICIAL',
            actionName: 'get_csv_data_multiple',
            inputUiInfo: {
              customizedInputs: {},
            },
            packageType: 'REGISTRY',
            pieceVersion: '~0.8.1',
            executionOptions: {
              executeOnce: {
                value: false,
              },
            },
            errorHandlingOptions: {
              retryOnFailure: {
                value: false,
              },
              continueOnFailure: {
                value: false,
              },
            },
          },
          displayName: 'Export multiple data in CSV Format',
        },
        {
          name: 'step_3',
          skip: false,
          type: 'PIECE',
          valid: true,
          settings: {
            input: {
              key: 'ids',
              value: "{{step_1[0]['_id']}}",
              store_scope: 'COLLECTION',
              ignore_if_exists: false,
            },
            position: {
              x: 600,
              y: 0,
            },
            pieceName: '@activepieces/piece-store',
            pieceType: 'OFFICIAL',
            actionName: 'add_to_list',
            inputUiInfo: {
              customizedInputs: {},
            },
            packageType: 'REGISTRY',
            pieceVersion: '~0.5.4',
            executionOptions: {
              executeOnce: {
                value: false,
              },
            },
            errorHandlingOptions: {
              retryOnFailure: {
                value: false,
              },
              continueOnFailure: {
                value: false,
              },
            },
          },
          displayName: 'Add data ids',
        },
        {
          name: 'step_5',
          skip: false,
          type: 'PIECE',
          valid: true,
          settings: {
            input: {
              key: 'ids',
              store_scope: 'COLLECTION',
            },
            position: {
              x: 800,
              y: 0,
            },
            pieceName: '@activepieces/piece-store',
            pieceType: 'OFFICIAL',
            actionName: 'get',
            inputUiInfo: {
              customizedInputs: {},
            },
            packageType: 'REGISTRY',
            pieceVersion: '~0.5.4',
            executionOptions: {
              executeOnce: {
                value: false,
              },
            },
            errorHandlingOptions: {
              retryOnFailure: {
                value: false,
              },
              continueOnFailure: {
                value: false,
              },
            },
          },
          displayName: 'Get all IDs',
        },
        {
          name: 'step_6',
          skip: false,
          type: 'PIECE',
          valid: true,
          settings: {
            input: {
              file: '{{step_2}}',
              fileName: 'Export',
              include_team_drives: false,
            },
            position: {
              x: 1200,
              y: 0,
            },
            pieceName: '@activepieces/piece-google-drive',
            pieceType: 'OFFICIAL',
            actionName: 'upload_gdrive_file',
            inputUiInfo: {
              customizedInputs: {},
            },
            packageType: 'REGISTRY',
            pieceVersion: '~0.5.35',
            executionOptions: {
              executeOnce: {
                value: false,
              },
            },
            errorHandlingOptions: {
              retryOnFailure: {
                value: false,
              },
              continueOnFailure: {
                value: false,
              },
            },
          },
          displayName: 'Upload on Google Drive',
        },
        {
          name: 'step_7',
          skip: false,
          type: 'PIECE',
          valid: true,
          settings: {
            input: {
              key: 'ids',
              store_scope: 'COLLECTION',
            },
            position: {
              x: 400,
              y: 0,
            },
            pieceName: '@activepieces/piece-store',
            pieceType: 'OFFICIAL',
            actionName: 'remove_value',
            inputUiInfo: {
              customizedInputs: {},
            },
            packageType: 'REGISTRY',
            pieceVersion: '~0.5.4',
            executionOptions: {
              executeOnce: {
                value: false,
              },
            },
            errorHandlingOptions: {
              retryOnFailure: {
                value: false,
              },
              continueOnFailure: {
                value: false,
              },
            },
          },
          displayName: 'Remove values',
        },
      ],
      connections: [
        {
          sourceId: 'trigger',
          targetId: 'step_7',
        },
        {
          sourceId: 'step_1',
          targetId: 'step_7',
        },
        {
          sourceId: 'step_7',
          targetId: 'step_3',
        },
        {
          sourceId: 'step_3',
          targetId: 'step_5',
        },
        {
          sourceId: 'step_5',
          targetId: 'step_2',
        },
        {
          sourceId: 'step_2',
          targetId: 'step_6',
        },
      ],
      valid: false,
      schemaVersion: '1',
      dynamicPropertiesValues: {},
    },
    blogUrl: '',
    projectId: '',
    platformId: '',
    type: TemplateType.PROJECT,
  },
  {
    id: 'google-calendar_new_or_updated_event-to-kizeo-forms_push_planning',
    created: '1767772900656',
    updated: '1767772900656',
    name: 'Push planning Kizeo Forms depuis Google Agenda',
    description:
      'Create a push planning in Kizeo Forms based on events created in Google Calendar',
    tags: [],
    pieces: [
      '@activepieces/piece-google-calendar',
      '@activepieces/piece-date-helper',
      '@activepieces/piece-kizeo-forms',
    ],
    template: {
      displayName: 'untitled',
      triggers: [
        {
          name: 'trigger',
          valid: true,
          displayName: 'New or Updated Event',
          type: TriggerType.PIECE,
          settings: {
            pieceName: '@activepieces/piece-google-calendar',
            pieceVersion: '0.5.6',
            pieceType: PieceType.OFFICIAL,
            packageType: PackageType.REGISTRY,
            input: {
              expandRecurringEvent: false,
            },
            inputUiInfo: {
              customizedInputs: {},
            },
            position: {
              x: 0,
              y: 0,
            },
            triggerName: 'new_or_updated_event',
          },
        },
      ],
      actions: [
        {
          name: 'step_2',
          skip: false,
          type: 'PIECE',
          valid: true,
          settings: {
            input: {
              inputDate: "{{trigger['end']['dateTime']}}",
              inputFormat: 'YYYY-MM-DDTHH:mm:ss',
              outputFormat: 'YYYY-MM-DD HH:mm:ss',
              inputTimeZone: 'Europe/Paris',
              outputTimeZone: 'Europe/Paris',
            },
            position: {
              x: 200,
              y: 0,
            },
            pieceName: '@activepieces/piece-date-helper',
            pieceType: 'OFFICIAL',
            actionName: 'format_date',
            inputUiInfo: {
              customizedInputs: {
                inputFormat: false,
              },
            },
            packageType: 'REGISTRY',
            pieceVersion: '0.1.6',
            executionOptions: {
              executeOnce: {
                value: false,
              },
            },
            errorHandlingOptions: {
              retryOnFailure: {
                value: false,
              },
              continueOnFailure: {
                value: false,
              },
            },
          },
          displayName: 'Format Date',
        },
        {
          name: 'step_3',
          skip: false,
          type: 'PIECE',
          valid: true,
          settings: {
            input: {
              fields: {},
              planningEnd: "{{step_2['result']}}",
              planningStart: "{{step_1['result']}}",
            },
            position: {
              x: 600,
              y: 0,
            },
            pieceName: '@activepieces/piece-kizeo-forms',
            pieceType: 'OFFICIAL',
            actionName: 'push_planning',
            inputUiInfo: {
              customizedInputs: {},
            },
            packageType: 'REGISTRY',
            pieceVersion: '0.8.1',
            executionOptions: {
              executeOnce: {
                value: false,
              },
            },
            errorHandlingOptions: {
              retryOnFailure: {
                value: false,
              },
              continueOnFailure: {
                value: false,
              },
            },
          },
          displayName: 'Push Planning',
        },
        {
          name: 'step_1',
          skip: false,
          type: 'PIECE',
          valid: true,
          settings: {
            input: {
              inputDate: "{{trigger['start']['dateTime']}}",
              inputFormat: 'YYYY-MM-DDTHH:mm:ss',
              outputFormat: 'DDD MMM DD HH:mm:ss YYYY',
              inputTimeZone: 'Europe/Paris',
              outputTimeZone: 'Europe/Paris',
            },
            position: {
              x: 400,
              y: 0,
            },
            pieceName: '@activepieces/piece-date-helper',
            pieceType: 'OFFICIAL',
            actionName: 'format_date',
            inputUiInfo: {
              customizedInputs: {},
            },
            packageType: 'REGISTRY',
            pieceVersion: '0.1.6',
            executionOptions: {
              executeOnce: {
                value: false,
              },
            },
            errorHandlingOptions: {
              retryOnFailure: {
                value: false,
              },
              continueOnFailure: {
                value: false,
              },
            },
          },
          displayName: 'Format Date',
        },
      ],
      connections: [
        {
          sourceId: 'trigger',
          targetId: 'step_2',
        },
        {
          sourceId: 'step_2',
          targetId: 'step_1',
        },
        {
          sourceId: 'step_1',
          targetId: 'step_3',
        },
      ],
      valid: true,
      schemaVersion: '1',
      dynamicPropertiesValues: {},
    },
    blogUrl: '',
    projectId: '',
    platformId: '',
    type: TemplateType.PROJECT,
  },
  {
    id: 'kizeo-forms_event_on_data_pushed-to-google-drive_upload_gdrive_file',
    created: '1767773324132',
    updated: '1767773324132',
    name: 'Standard PDF for each data entry saved to Drive',
    description:
      'Automatically upload a standard PDF to Drive for each completed data entry',
    tags: [],
    pieces: [
      '@activepieces/piece-kizeo-forms',
      '@activepieces/piece-google-drive',
    ],
    template: {
      displayName: 'untitled',
      triggers: [
        {
          name: 'trigger',
          valid: true,
          displayName: 'Event On Data Pushed',
          type: TriggerType.PIECE,
          settings: {
            pieceName: '@activepieces/piece-kizeo-forms',
            pieceVersion: '~0.8.1',
            pieceType: PieceType.OFFICIAL,
            packageType: PackageType.REGISTRY,
            input: {
              format: 'advanced',
            },
            inputUiInfo: {
              customizedInputs: {},
            },
            position: {
              x: 0,
              y: 0,
            },
            triggerName: 'event_on_data_pushed',
          },
        },
      ],
      actions: [
        {
          name: 'step_1',
          type: 'PIECE',
          valid: true,
          settings: {
            input: {
              dataId: "{{trigger['data']['id']}}",
            },
            position: {
              x: 200,
              y: 0,
            },
            pieceName: '@activepieces/piece-kizeo-forms',
            pieceType: 'OFFICIAL',
            actionName: 'download_standard_pdf',
            inputUiInfo: {
              customizedInputs: {},
            },
            packageType: 'REGISTRY',
            pieceVersion: '~0.8.1',
            executionOptions: {
              executeOnce: {
                value: false,
              },
            },
            errorHandlingOptions: {
              retryOnFailure: {
                value: false,
              },
              continueOnFailure: {
                value: false,
              },
            },
          },
          displayName: 'Download Standard PDF',
        },
        {
          name: 'step_2',
          skip: false,
          type: 'PIECE',
          valid: false,
          settings: {
            input: {
              file: '{{step_1}}',
              include_team_drives: false,
            },
            position: {
              x: 400,
              y: 0,
            },
            pieceName: '@activepieces/piece-google-drive',
            pieceType: 'OFFICIAL',
            actionName: 'upload_gdrive_file',
            inputUiInfo: {
              customizedInputs: {},
            },
            packageType: 'REGISTRY',
            pieceVersion: '~0.5.35',
            executionOptions: {
              executeOnce: {
                value: false,
              },
            },
            errorHandlingOptions: {
              retryOnFailure: {
                value: false,
              },
              continueOnFailure: {
                value: false,
              },
            },
          },
          displayName: 'Upload file',
        },
      ],
      connections: [
        {
          sourceId: 'trigger',
          targetId: 'step_1',
        },
        {
          sourceId: 'step_1',
          targetId: 'step_2',
        },
      ],
      valid: false,
      schemaVersion: '1',
      dynamicPropertiesValues: {},
    },
    blogUrl: '',
    projectId: '',
    platformId: '',
    type: TemplateType.PROJECT,
  },
  {
    id: 'google-sheets_googlesheets_new_row_added-to-kizeo-forms_push_planning',
    created: '1767773766309',
    updated: '1767773766309',
    name: 'Push Kizeo Forms planning from Google Sheets',
    description:
      'Automatically send a push planning from each new Google Sheets row',
    tags: [],
    pieces: [
      '@activepieces/piece-google-sheets',
      '@activepieces/piece-kizeo-forms',
      '@activepieces/piece-date-helper',
    ],
    template: {
      displayName: 'New line in Gsheet to Push Planning',
      triggers: [
        {
          name: 'trigger',
          valid: true,
          displayName: 'New Row Added',
          type: TriggerType.PIECE,
          settings: {
            pieceName: '@activepieces/piece-google-sheets',
            pieceVersion: '~0.12.12',
            pieceType: PieceType.OFFICIAL,
            packageType: PackageType.REGISTRY,
            input: {
              includeTeamDrives: false,
            },
            inputUiInfo: {
              customizedInputs: {},
            },
            position: {
              x: 0,
              y: 0,
            },
            triggerName: 'googlesheets_new_row_added',
          },
        },
      ],
      actions: [
        {
          name: 'step_2',
          skip: false,
          type: 'PIECE',
          valid: true,
          settings: {
            input: {
              fields: {
                info_1: "{{trigger['values']['F']}}",
                info_2: "{{trigger['values']['G']}}",
                info_3: "{{trigger['values']['H']}}",
                quelle_section: "{{trigger['values']['E']}}",
              },
              planningEnd: "{{step_1['result']}}",
              planningStart: "{{step_1['result']}}",
            },
            position: {
              x: 400,
              y: 0,
            },
            pieceName: '@activepieces/piece-kizeo-forms',
            pieceType: 'OFFICIAL',
            actionName: 'push_planning',
            inputUiInfo: {
              customizedInputs: {
                userId: true,
                quelle_section: true,
              },
            },
            packageType: 'REGISTRY',
            pieceVersion: '~0.8.1',
            executionOptions: {
              executeOnce: {
                value: false,
              },
            },
            errorHandlingOptions: {
              retryOnFailure: {
                value: false,
              },
              continueOnFailure: {
                value: false,
              },
            },
          },
          displayName: 'Push Planning',
        },
        {
          name: 'step_1',
          skip: false,
          type: 'PIECE',
          valid: false,
          settings: {
            input: {
              inputFormat: 'DD/MM/YYYY',
              outputFormat: 'YYYY-MM-DDTHH:mm:ss',
              inputTimeZone: 'Europe/Paris',
              outputTimeZone: 'Europe/Paris',
            },
            position: {
              x: 200,
              y: 0,
            },
            pieceName: '@activepieces/piece-date-helper',
            pieceType: 'OFFICIAL',
            actionName: 'format_date',
            inputUiInfo: {
              customizedInputs: {},
            },
            packageType: 'REGISTRY',
            pieceVersion: '~0.1.6',
            executionOptions: {
              executeOnce: {
                value: false,
              },
            },
            errorHandlingOptions: {
              retryOnFailure: {
                value: false,
              },
              continueOnFailure: {
                value: false,
              },
            },
          },
          displayName: 'Format Date',
        },
      ],
      connections: [
        {
          sourceId: 'step_1',
          targetId: 'step_2',
        },
        {
          sourceId: 'trigger',
          targetId: 'step_1',
        },
      ],
      valid: false,
      schemaVersion: '1',
      dynamicPropertiesValues: {},
    },
    blogUrl: '',
    projectId: '',
    platformId: '',
    type: TemplateType.PROJECT,
  },
];
